import React, { useState, useRef, useEffect } from "react";

import { PictureUploadWrapper } from "./style";
import { isEmpty } from "../../Utils/common";
import fileIcon from "../../images/file.png";

const UploadSvg = () => (
  <svg className="uploadSvg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="17 8 12 3 7 8" />
    <line x1="12" y1="3" x2="12" y2="15" />
  </svg>
);

const PictureUpload = ({
  setImage = () => {},
  image = "",
  accept = "image/jpeg,image/png,image/jpg",
  type = "image",
}) => {
  const [fileName, setFileName] = useState(null);
  const [preview, setPreview] = useState("");
  const fileInputRef = useRef(null);

  const handleFileChange = (event) => {
    try {
      const selectedFile = event.target.files[0];
      // setFile(selectedFile);
      setImage(selectedFile);
      setFileName(selectedFile.name);

      setPreview(URL.createObjectURL(selectedFile));
    } catch (error) {}
  };

  const handleDrop = (event) => {
    try {
      event.preventDefault();
      const droppedFile = event.dataTransfer.files[0];
      // setFile(droppedFile);
      setImage(droppedFile);
      setFileName(droppedFile.name);
      setPreview(URL.createObjectURL(droppedFile));
    } catch (error) {}
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const handleRemove = (e) => {
    e.stopPropagation();
    // setFile(null);
    setImage(null);
    setPreview("");
    setFileName("");
    fileInputRef.current.value = null;
  };

  useEffect(() => {
    if (isEmpty(image)) return;
    setPreview(image);
  }, [image]);

  return (
    <PictureUploadWrapper
      className="file-upload"
      onDrop={handleDrop}
      onDragOver={handleDragOver}
      onClick={handleClick}
    >
      {preview ? (
        <>
          {type === "image" ? (
            <div className="preview-container">
              <img
                src={preview}
                alt="Preview"
                style={{ width: "100%", height: "auto" }}
              />
              <span className="remove-icon" onClick={handleRemove}>
                &#10005;
              </span>
            </div>
          ) : (
            <div className="showTextImg">
              <div>
                <span className="remove-icon" onClick={handleRemove}>
                  &#10005;
                </span>
                <img src={fileIcon} alt="" />
                <p
                  style={{
                    marginInline: "0",
                    maxWidth: "100%",
                    textAlign: "center",
                    marginTop: "20px",
                  }}
                >
                  {fileName}
                </p>
              </div>
            </div>
          )}
        </>
      ) : (
        <div className="showTextImg">
          <div>
            <UploadSvg />
            <p style={{ padding: "20px" }}>
              Drag &amp; Drop your file here or click to select a file
            </p>
          </div>
        </div>
      )}
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        accept={accept}
        style={{ display: "none" }}
      />
    </PictureUploadWrapper>
  );
};

export default PictureUpload;
